"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const three_1 = require("three");
const PointToPointLeader_3d_1 = __importDefault(require("./PointToPointLeader.3d"));
class PointToPointDashedLeader extends PointToPointLeader_3d_1.default {
    createLine(startPoint, endPoint) {
        const dashedLine = new three_1.LineSegments(new three_1.BufferGeometry().setFromPoints([startPoint, endPoint]), this.lineMaterial);
        dashedLine.computeLineDistances();
        const group = new three_1.Group();
        group.add(dashedLine);
        return group;
    }
}
exports.default = PointToPointDashedLeader;
